module.exports = __webpack_public_path__ + "img/bank-02-woori.37bcc709.svg";